import { useState } from 'react';

import { MarketSearchOptions } from '../tabs/marketDashboard';
import { dataGridFetchData } from '../../../services/datagrid';
import { formatDateYYYYMMDDPacific } from '../../../utilities/dateHelpers';

const ActiveColumns = [
    'mls_history.listing_date',
    'mls_history.sold_date',
    'mls_history.listing_price',
    'mls_history.sold_price',
    'mls_history.mls_listing_id',
    'mls_history.year_built',
];

function getPacificDate(date = new Date()) {
    const pacificString = date.toLocaleString('en-US', {
        timeZone: 'America/Los_Angeles',
    });
    return new Date(pacificString);
}

function getStartDate(dateWindowOption) {
    const today = getPacificDate();
    const startDate = getPacificDate();
    switch (dateWindowOption) {
    case 'Last month':
        startDate.setDate(today.getDate() - 4 * 7);
        break;
    case 'Last 3 months':
        startDate.setDate(today.getDate() - 13 * 7);
        break;
    case 'Last 6 months':
        startDate.setDate(today.getDate() - 26 * 7);
        break;
    case 'Last 12 months':
        startDate.setDate(today.getDate() - 52 * 7);
        break;
    case 'Last 24 months':
        startDate.setDate(today.getDate() - 2 * 52 * 7);
        break;
    }
    return startDate;
}

function useGetHomesForSale() {
    const [marketLoading, setMarketLoading] = useState(false);
    const [apiError, setApiError] = useState(false);
    const [marketData, setMarketData] = useState([]);

    async function executeSearch(filters, columns) {
        setMarketLoading(true);
        setApiError(false);
        setMarketData([]);
        const qlString = filters.join(' AND ');
        const payload = {
            columns: columns,
            filters: qlString,
            ordering: [],
        };
        const resp = await dataGridFetchData(payload);
        if (resp?.data) {
            const data = resp.data.map((row) =>
                Object.fromEntries(columns.map((col, i) => [col, row[i]])),
            );
            setMarketData(data);
        } else if (resp?.error) {
            setApiError(true);
        }
        setMarketLoading(false);
    }

    function doSearch(searchOptions) {
        const filters = [];
        if (searchOptions[MarketSearchOptions.Location] !== 'All Locations') {
            filters.push(
                `city.name IN ('${searchOptions[MarketSearchOptions.Location]}')`,
            );
        }
        filters.push(
            `property_geometry.lot_size_sq_ft_coa<=${searchOptions[MarketSearchOptions.MaxLotSize]}`,
        );
        filters.push(
            `property_structure.building_sq_ft_coa<=${searchOptions[MarketSearchOptions.MaxBldSize]}`,
        );
        filters.push(
            `property_geometry.lot_size_sq_ft_coa>=${searchOptions[MarketSearchOptions.MinLotSize]}`,
        );
        filters.push(
            `property_structure.building_sq_ft_coa>=${searchOptions[MarketSearchOptions.MinBldSize]}`,
        );
        filters.push(
            'mls_history.property_use_standardized=\'SINGLE FAMILY RESIDENCE\'',
        );
        const start = getStartDate('Last 12 months');
        filters.push(
            `mls_history.listing_date>='${formatDateYYYYMMDDPacific(start)}'`,
        );
        filters.push(
            `mls_history.listing_date<='${formatDateYYYYMMDDPacific(
                getPacificDate(),
            )}'`,
        );
        filters.push('mls_history.listing_status IN (\'A\',\'C\')');
        filters.push('mls_history.listing_price<=100000000');

        executeSearch(filters, ActiveColumns);
    }

    return {
        doSearch,
        marketLoading,
        marketData,
        apiError,
    };
}

export default useGetHomesForSale;
